import React from 'react';
import {PrimaryButton} from 'Components/Button';

import Authenticated from 'Components/Layouts/Authenticated';

import { Loading } from "Components/Partials";
import Users from "Services/Api/Networking/Users";
import { Modal } from "Services";
import StandAloneChatModel from "Components/Partials/Modals/StandAloneChatModel";
import { Link } from "Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { translation } from "Services/TranslationHelpers";
import OrangeButton from "Components/Button/OrangeButton";
import PaginationBar from "../../Components/Partials/PaginationBar";
import { asset } from "Services/BaseHelpers";

export default class WhoWho extends React.Component {

    state = {
        exhibitor: null,
        notFound: null,
        working: false,
        users: [],
        search: '',
        page: 1,
        pageCount: 0,
        total: 0,
    };

    constructor(props) {
        super ( props );

        //get exhibitor data from the url
        this.exhibitor_id = this.props.match.params.exhibitor_id;
    }

    handleSearch = (e) => {
        // Get the new search value
        const searchValue = e.target.value;

        if (this.timeout) clearTimeout(this.timeout);

        // Set the new search value to the state and debounce the fetchUsers function
        this.setState({
            search: searchValue,
        });

        this.timeout = setTimeout(this.fetchUsers, 500);

    }

    fetchUsers = async (page = 1) => {
        this.setState({ working: true });
        const response = await Users.enabled({filter_by_same_person: true, search: this.state.search, page });
        if (response) {
            this.setState({
                users: response.data,
                working: false,
            });
        }
    }

    renderSearchBar = () => {

        return (
            <div className="mx-auto flex justify-center relative z-10 mb-16">
                <input
                    type="text"
                    className={`w-11/12 mt-6 border-0 bg-app-light-blue rounded-full text-white
                        outline-none focus:outline-none focus:border-0 focus:ring-0 font-bold py-3 placeholder-white pl-10`}
                    placeholder={translation('misc', 'search')}
                    onChange={this.handleSearch}
                    value={this.state.search}
                />

                <FontAwesomeIcon
                    icon={faSearch}
                    size="1x"
                    className="h-6 w-6 absolute top-9 right-16 text-white"
                />
            </div>
        );
    }

    async componentDidMount() {
        await this.fetchUsers();
    }

    navigateChatLink = (user) => {
        Modal.open({
            component: StandAloneChatModel,
            props: {
                user: user
            }
        });
    };

    handlePageChange = async ( page ) => {
        await this.fetchUsers ( page );
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { users, working, page, pageCount, total } = this.state;

        return (
            <Authenticated pageTitle="Who's Who" headerImage={'/images/headers/whos-who.png'}>
                <div className={ "max-w-7xl mx-auto p-5" }>

                    <p className=" text-center px-6 text-app-blue my-10 text-lg">
                        Check out who else is attending and update your own profile to facilitate networking.
                    </p>

                    { working && (
                        <Loading />
                    ) }

                    <div className={ "flex justify-center m-auto mt-6 w-full" }>
                        <Link
                            to="/settings/profile"
                            className="text-app-green-banner text-4xl mx-auto"
                        >
                            <PrimaryButton
                                text={ "Create your profile and begin networking" }
                                className={ "mx-auto" }
                            />
                        </Link>
                    </div>

                    { this.renderSearchBar() }

                    { (!working && users && users.data) && (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 w-full mx-auto">
                            { users.data.map ( user => (
                                <div
                                    key={ user.id }
                                    className=" p-4 cursor-pointer bg-app-gray"
                                >
                                    {/*{ this.UserAvatar ( user ) }*/}
                                    <h2 className="text-xl text-center  font-bold uppercase text-app-blue mt-4">{ user.name }</h2>
                                    <h2 className="text-sm text-center text-app-blue">{ user.job_title }</h2>
                                    <h2 className="text-sm text-center text-app-blue font-bold">{ user.company_name }</h2>

                                    <div className={ "flex justify-center mt-4" }>
                                        <OrangeButton
                                            text={ "View Profile" }
                                            onClick={ () => this.navigateChatLink ( user ) }
                                        />
                                    </div>
                                </div>
                            ) ) }
                        </div>
                    ) }

                    { !working && users && users.data && users.meta && (
                        <PaginationBar
                            total={users.meta.total}
                            pageCount={users.meta.last_page}
                            page={users.meta.current_page}
                            className="my-10"
                            goToPage={this.handlePageChange}
                        />
                    ) }
                </div>
            </Authenticated>
        )
            ;
    }

    UserAvatar( user ) {
        if ( user.avatar_path && user.avatar_path.url ) {
            return <img
                src={ user.avatar_path.url }
                alt={ user.name }
                className="w-32 h-32 object-cover  mx-auto flex items-center justify-center "
            />;
        } else {
            return <img
                src={ asset( '/images/placeholder-profile.png' ) }
                alt={ user.name }
                className="w-32 h-32 object-cover  mx-auto flex items-center justify-center "
            />;
        }
    }
}
